import Step1 from './step1.base64'
import Step2 from './step2.base64'
import Step3 from './step3.base64'

export default { Step1, Step2, Step3 }